import * as React from 'react';
import { AppContextData } from './AppContextData';
import { AppContextFromSearch } from './AppContextFromSearch';
import { AppContextFromCronos } from './AppContextFromCronos';
import { WhitelabelId } from '@whitelabel/WhitelabelId';
import { isInIframe } from '@utils/isInIframe';
import { AppPlatform } from '@contexts/app/AppPlatform';

export const defaultAppContextFromCronos: AppContextFromCronos = {
    cultureCode: 'en-us',
    devicePlatformId: 0,
    cid: -1,
    aid: 130243,
    trafficGroupId: 130243,
    userId: 'default-user-id',
    origin: 'default-origin',
    sessionId: 'default-session-id',
    correlationId: 'default-correlation-id',
    languageId: 1,
    whitelabelId: WhitelabelId.AGODA,
    clientVersion: '0.0.0',
    machineName: 'default-machinename',
    currency: 'usd',
    optInEmailSubscription: false,
    isWebView: false,
    wlAppDeviceType: '',
    blockedPhoneCountryCodes: '',
    additionalRegex: {},
    isCnTunnel: false,
};

export const defaultAppContextFromSearch: AppContextFromSearch = {
    appVersion: '0.0.0',
    appId: 'default-appId',
    rpcId: 'default-rpcId',
    iframeSize: {
        width: 100,
        height: 100,
    },
    debugMode: false,
    fullScreen: false,
    useExternalRoute: false,
    useExternalNotification: false,
};

export const defaultYcsAppContextFromSearch: AppContextFromSearch = {
    appVersion: '0.0.0',
    appId: 'ycs',
    rpcId: 'default-rpcId',
    iframeSize: {
        width: 100,
        height: 100,
    },
    debugMode: false,
    fullScreen: false,
    useExternalRoute: false,
    useExternalNotification: false,
};

export const defaultAppContext: AppContextData = {
    ...defaultAppContextFromCronos,
    ...defaultAppContextFromSearch,
    iframeMode: isInIframe(),
    ulApiUrl: window.location.origin,
    appPlatform: AppPlatform.WEB,
};

export const defaultYcsContext: AppContextData = {
    ...defaultAppContextFromCronos,
    ...defaultYcsAppContextFromSearch,
    iframeMode: isInIframe(),
    ulApiUrl: window.location.origin,
    appPlatform: AppPlatform.WEB,
};

export const AppContext = React.createContext<AppContextData>(defaultAppContext);
AppContext.displayName = 'AppContext';
